import View from "./view.js";
import WebMercatorViewport from "../viewports/web-mercator-viewport.js";
import MapController from "../controllers/map-controller.js";
export default class MapView extends View {
    static { this.displayName = 'MapView'; }
    constructor(props = {}) {
        super(props);
    }
    get ViewportType() {
        return WebMercatorViewport;
    }
    get ControllerType() {
        return MapController;
    }
}
